import { useCallback } from 'react'

import { useAppSelector, useAppDispatch } from 'store/store'

import * as actions from './actions'

export const useNotification = () => {
  const dispatch = useAppDispatch()
  const notificationState = useAppSelector(({ notification }) => notification)
  const notifactions = notificationState.notifactions || []

  const getNotifications = useCallback(() => {
    dispatch(actions.getAllNotifications())
  }, [dispatch])

  const markAsRead = useCallback(
    (id: string) => {
      dispatch(actions.markNotificationAsRead(id))
    },
    [dispatch],
  )

  const markAllAsRead = useCallback(() => {
    dispatch(actions.markAllNotificationsAsRead())
  }, [dispatch])

  return {
    ...notificationState,
    getNotifications,
    notifactions,
    markAsRead,
    markAllAsRead,
  }
}
